import React, { Component } from 'react';

import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Collapse,
  Table
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome,
  faChevronCircleDown,
  faChevronCircleLeft,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import Datatable from './components/Datatable.js';

class SocialCard extends Component {
  constructor(props) {
    super(props); 
    this.state = {
      collapse: this.props.category === "Social" ? true : false,
      buttonText: "Expand",
      isHovered: null
    };
  }

  toggle() {
    if(this.state.collapse) {
      this.setState({
        collapse: false,
        buttonText: "Expand"
      }); 
    } else {
      this.setState({
        collapse: true,
        buttonText: "Shrink"
      });  
    }
  }

  handleMouseEnter() {
    this.setState({ isHovered: true }); 
  }

  handleMouseLeave() {
    this.setState({ isHovered: false }); 
  }

  hasColumns(columns) {
    let data = this.props.currentDistrictsData;
    let hasColumns = false;  

    columns.forEach((item) => {
      if(data[item.column]) {
        hasColumns = true; 
      }
    });

    return hasColumns;
  }

  render() {
    const { dataPointNames } = this.props;
    const tableColumns = dataPointNames.filter(dataPointName => dataPointName.category === "Social & Wellness")
      .map((dataPointName) => {
        return {title: dataPointName.title ? dataPointName.title : dataPointName.name, column: dataPointName.name}
      });

    return (
      <Card className="mb-2 data-category-card">
        <CardHeader
          className={(this.state.isHovered ? "bg-secondary" : "bg-primary") + " text-white d-flex flex-row"}
          onMouseEnter={this.handleMouseEnter.bind(this)}
          onMouseLeave={this.handleMouseLeave.bind(this)}
          onClick={this.toggle.bind(this)}
          style={ this.state.collapse ? {alignItems: "center"} : {alignItems: "center", borderRadius: "calc(0.25rem - 1px)"} }>
          <h4 className="mb-0">
            <span className="fa-layers fa-fw mr-4">
              <FontAwesomeIcon icon={faCircle} transform="grow-15" />
              <FontAwesomeIcon icon={faHome} />
            </span>
            Employment
          </h4>
          <h3 className="mb-0 ml-auto"><FontAwesomeIcon size="lg" icon={this.state.collapse ? faChevronCircleLeft : faChevronCircleDown} /></h3>
        </CardHeader>
        <Collapse isOpen={this.state.collapse}>
          <CardBody className={ this.props.loading ? "text-center" : null }>
            { this.props.loading ?
              <FontAwesomeIcon icon={faSpinner} size="6x" spin className="m-5 text-primary" />
              :
              <div>
                { this.hasColumns(tableColumns) ?
                  <div>
                    <Datatable 
                      title=""
                      columns={tableColumns}
                      currentDistrictsData={this.props.currentDistrictsData} />
                  </div>
                    :
                    <p>No data available.</p> }
              </div> }
          </CardBody>
        </Collapse>
      </Card>
    ); 
  }
}

export default SocialCard;
